import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { Observable } from 'rxjs';
import {
  EmployeeContactConvener,
  EmployeeContactUser
} from './../../../shared/employee-contact';
import { User } from '../../contractor/models/contractor';
import { UserService } from './user.service';

@Injectable()
export class UserListResolver {
  constructor(private backend: UserService) {}
  resolve(): Observable<User[]> {
    return this.backend.getUsersByBusiness(BaseServices.BusinessId);
  }
}
@Injectable()
export class DeviationUserListResolver {
  constructor(private backend: UserService) {}
  resolve(): Observable<User[]> {
    return this.backend.getDeviationCreatedByUsers();
  }
}

@Injectable()
export class UserEditResolver {
  constructor(private backend: UserService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<User[]> {
    return this.backend.getUsersById(+route.params['uid']);
  }
}

@Injectable()
export class UserRoleResolver {
  constructor(private backend: UserService) {}
  resolve(): Observable<any> {
    return this.backend.getRoles();
  }
}

/**
 * common resolver for employees/contacts with businessid
 */
@Injectable()
export class EmployeeContactUserResolver
{
  constructor(private backend: UserService) {}
  resolve(route: ActivatedRouteSnapshot) {
    // For admin and portal levels, load all users from application/portal
    const skipAdmin = route.data && route.data['skipAdminPreloads'] === true;
    if (BaseServices.roleId === '1') {
      // Admin level - optionally skip preloading to let page fetch lazily
      if (skipAdmin) {
        return [] as any;
      }
      return this.backend.getEmployeeContactUsers(0); // 0 means all businesses in application
    } else if (BaseServices.roleId === '2') {
      // Portal level - load all users from portal using the new portal-specific method
      return this.backend.getEmployeeContactUsersPortal(BaseServices.PortalId);
    } else if (BaseServices.BusinessId != 0) {
      // Business level - load users from specific business
      return this.backend.getEmployeeContactUsers(BaseServices.BusinessId);
    }
    return [];
  }
}

/**
 * common resolver for employees/contacts subscription with businessid
 */
@Injectable()
export class EmployeeContactUserSubscriptionResolver {
  constructor(private backend: UserService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return this.backend.getEmployeeContactSubscriptionUsers(
      BaseServices.BusinessId
    );
  }
}
